<section id="content" ng-controller="OrderListController" ng-init="payments()" ng-class="loading ? 'loading' : ''">
<div class="row">
    <div class="col-md-12">
        <div class="panel">
            <div class="panel-body pn">
                <div class="table-responsive" ng-if="data.payments.length > 0">
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th>İşlem Numarası</th>
                            <th>Paket</th>
                            <th>İşlem Tarihi</th>
                            <th>Miktar</th>
                            <th class="text-right">#</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="item in data.payments">
                                <td>{{ item.id }}</td>
                                <td>{{ item.package.name }}</td>
                                <td>{{ item.created_at  | amUtc | amDateFormat:'DD.MM.YYYY' }}</td>
                                <td>{{ item.package.day | number:0 }} Gün</td>
                                <td class="text-right">
                                    <a href="/odeme-bilgileri/{{ item.id }}" class="btn btn-sm btn-warning">Detaylı Gör</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-responsive" ng-if="data.payments.length == 0">
                    <strong>Bu tarihte hiçbir hareket yoktur.</strong>
                </div>
            </div>
        </div>
    </div>
</div>
</section>